import React from "react";
import { Card, Icon, Tooltip, InputNumber, Tag } from "antd";
import "./styles.css";
import enemyabilitylist from "../utilities/enemyabilitylist";

const reactStringReplace = require("react-string-replace");

const typelist = [
  {
    text: "White",
    value: "white",
    colour: "#F8F8F8",
  },
  {
    text: "Red",
    value: "red",
    colour: "#FEABAC",
  },
  {
    text: "Alien",
    value: "alien",
    colour: "#A2FFEC",
  },
  {
    text: "Floating",
    value: "floating",
    colour: "#8CFD8D",
  },
  {
    text: "Black",
    value: "black",
    colour: "#1c1d1f",
  },
  {
    text: "Metal",
    value: "metal",
    colour: "#BBBBBB",
  },
  {
    text: "Angel",
    value: "angel",
    colour: "#FFFEAF",
  },
  {
    text: "Zombie",
    value: "zombie",
    colour: "#CB8CFC",
  },
  {
    text: "Relic",
    value: "relic",
    colour: "#84933C",
  },
  {
    text: "Aku",
    value: "aku",
    colour: "#5DA0CD",
  },
  {
    text: "Witch",
    value: "witch",
    colour: "#644324",
  },
  {
    text: "Eva",
    value: "eva",
    colour: "#644324",
  },
  {
    text: "Base",
    value: "dojo_base",
    colour: "#BBBBBB",
  },
  {
    text: "Colossal",
    value: "baron",
    colour: "#ffb442",
  },
  {
    text: "Behemoth",
    value: "beast",
    colour: "#ffb442",
  },
  {
    text: "Sage",
    value: "sage",
    colour: "#BBBBBB",
  },
];

class SingleEnemyCard extends React.Component {
  state = {
    multiplier: 100,
  };

  componentDidMount() {
    this.setState({ multiplier: this.props.multiplier });
  }

  onInputNumberChange(value) {
    if (value > 0 && value < 500000) {
      this.setState({
        multiplier: value,
      });
    }
  }

  getAbilityTags() {
    const abilitytags = [];
    const fullability = this.props.selectedEnemy["special_att_desc"];
    if (fullability) {
      enemyabilitylist.forEach(function (ability) {
        if (fullability.match(new RegExp(ability.value)) !== null) {
          abilitytags.push(
            <Tooltip
              placement="topLeft"
              title={ability.text}
              key={abilitytags.length}
            >
              {ability.img}
              <span style={{ display: "inline-block", width: "2px" }} />
            </Tooltip>
          );
        }
      });
    }
    return abilitytags;
  }

  getTypeTags() {
    const typetags = [];
    const fulltype = this.props.selectedEnemy;
    if (fulltype) {
      typelist.forEach(function (type) {
        const typevalue = type.value.toString();
        if (fulltype[typevalue]) {
          typetags.push(
            <Tag
              style={{
                fontSize: "12px",
                color: "#595959",
                borderColor: "#F1F1F1",
              }}
              color={type.colour}
            >
              {type.text}
            </Tag>
          );
        }
      });
    }
    return typetags;
  }

  render() {
    const dataSource = this.props.selectedEnemy;

    const multDamage =
      Math.round((dataSource.atk * this.state.multiplier) / 100).toString() +
      (dataSource.atk_2 > 0
        ? " / " +
          Math.round(
            (dataSource.atk_2 * this.state.multiplier) / 100
          ).toString()
        : "") +
      (dataSource.atk_3 > 0
        ? " / " +
          Math.round(
            (dataSource.atk_3 * this.state.multiplier) / 100
          ).toString()
        : "");

    const multDPS = Math.round((dataSource.dps * this.state.multiplier) / 100);
    const multHealth = Math.round(
      (dataSource.hp * this.state.multiplier) / 100
    );
    const effTarget = dataSource.att_type === "0" ? "Single" : "Area";

    const cardWidth =
      this.props.viewportWidth > 948
        ? this.props.viewportWidth / 3 - 4
        : this.props.viewportWidth > 636
        ? this.props.viewportWidth / 2 - 6
        : this.props.viewportWidth - 4;

    let abilitycopy = dataSource.special_att_desc;
    let formattedb = reactStringReplace(
      abilitycopy,
      /b1(.+?)b2/g,
      (match, i) => (
        <b key={match + i}>
          <br />
          {match}
        </b>
      )
    );
    let formattedu1 = reactStringReplace(
      formattedb,
      /\su1(.+?)u2/g,
      (match, i) => (
        <u key={match + i}>
          <br />
          {match}
        </u>
      )
    );

    let formattedu = reactStringReplace(
      formattedu1,
      /u1(.+?)u2/g,
      (match, i) => <u key={match + i}>{match}</u>
    );

    let flavourtextcopy = dataSource.flavour_text;
    let formattedft = reactStringReplace(
      flavourtextcopy,
      /(<br>)/g,
      (match, i) => " "
    );

    const gridStyleA = {
      width: "1/3%",
      textAlign: "center",
      padding: "4px",
      WebkitBoxShadow: "0 0 0 0",
      fontWeight: "bold",
      fontSize: "20px",
    };

    const gridStyleB = {
      width: "100%",
      textAlign: "center",
      padding: "4px",
      WebkitBoxShadow: "0 0 0 0",
      fontWeight: "bold",
      fontSize: "20px",
    };

    const gridStyleC = {
      textAlign: "center",
      fontWeight: "normal",
      fontSize: "14px",
      marginBottom: "0px",
    };

    const gridStyleD = {
      width: "100%",
      textAlign: "left",
      fontWeight: "normal",
      fontSize: "14px",
      marginBottom: "0px",
      WebkitBoxShadow: "0 0 0 0",
      padding: "0px 0 0 0",
    };

    const gridStyleE = {
      width: "100%",
      textAlign: "center",
      fontWeight: "normal",
      fontSize: "14px",
      marginBottom: "0px",
      WebkitBoxShadow: "0 0 0 0",
      padding: "0px 0 0 0",
    };

    const gridStyleF = {
      width: "100%",
      textAlign: "left",
      fontWeight: "normal",
      fontSize: "14px",
      marginBottom: "0px",
      WebkitBoxShadow: "0 0 0 0",
      padding: "12px 24px 12px 24px",
    };

    const catExists = (
      <div
        style={{
          display: "inline-block",
          padding: "0 12px 12px 0",
        }}
      >
        <Card
          title={
            <div>
              <div>
                <img
                  style={{
                    float: "left",
                    display: "inline-block",
                    padding: "0 6px 0 0 ",
                  }}
                  src={
                    "https://onestoppress.com/images/edi_" +
                    dataSource.enemy_no +
                    ".png"
                  }
                  // src={img}
                  alt={dataSource.name}
                />
                <div style={{ display: "-webkit-box" }}>
                  <h3
                    style={{
                      // float: "right",
                      overflowWrap: "break-word",
                      wordBreak: "break-word",
                      // maxWidth: "140px",
                      // height: "80px",
                      // display: "block",
                      whiteSpace: "normal",
                      // padding: "0 0 0 6px",
                      lineHeight: "1.3",
                      margin: "0px",
                    }}
                  >
                    {dataSource.enemy_name_en}
                    <br />
                    {this.getTypeTags()}
                    <br />
                  </h3>
                </div>
              </div>
            </div>
          }
          //   extra={dataSource.name}
          style={{
            minWidth: 300,
            maxWidth: 350,
            width: cardWidth,
            verticalAlign: "top",
          }}
          className="cardcss"
        >
          <Card.Grid style={gridStyleF}>
            <Card.Grid style={gridStyleD}>
              <div style={{ fontWeight: "bold" }}>Abilities</div>
              <div>{this.getAbilityTags()}</div>
              <hr />
            </Card.Grid>

            <Card.Grid style={gridStyleE}>
              <div style={{ padding: "4px", margin: "0 0 0 0" }}>
                Multiplier:&nbsp;
                <InputNumber
                  style={{ width: "55px" }}
                  min={1}
                  max={500000}
                  defaultValue={this.props.multiplier}
                  size="small"
                  step={50}
                  onChange={this.onInputNumberChange.bind(this)}
                />
                &nbsp;%
              </div>
            </Card.Grid>
            <Card.Grid style={gridStyleB}>
              {multDamage}
              <div style={gridStyleC}>Damage</div>
            </Card.Grid>
            <Card.Grid style={gridStyleA}>
              {multDPS}
              <div style={gridStyleC}>DPS</div>
            </Card.Grid>
            <Card.Grid style={gridStyleA}>
              {dataSource.range}
              <div style={gridStyleC}>Range</div>
            </Card.Grid>
            <Card.Grid style={gridStyleA}>
              {multHealth}
              <div style={gridStyleC}>Health</div>
            </Card.Grid>
            <Card.Grid style={gridStyleA}>
              {dataSource.kb}
              <div style={gridStyleC}>KB</div>
            </Card.Grid>
            <Card.Grid style={gridStyleA}>
              ${dataSource.money}
              <div style={gridStyleC}>Money</div>
            </Card.Grid>
            <Card.Grid style={gridStyleA}>
              {dataSource.speed}
              <div style={gridStyleC}>Speed</div>
            </Card.Grid>
            <Card.Grid style={gridStyleA}>
              {dataSource.real_tba}s
              <div style={gridStyleC}>
                TBA{" "}
                <Tooltip title="Time Between Attacks" placement="topLeft">
                  <Icon
                    type="info-circle"
                    style={{ fontSize: "12px", verticalAlign: "top" }}
                  />
                </Tooltip>
              </div>
            </Card.Grid>
            <Card.Grid style={gridStyleA}>
              {dataSource.pre_atk_anim}s<div style={gridStyleC}>Animation</div>
            </Card.Grid>
            <Card.Grid style={gridStyleA}>
              {effTarget}
              <div style={gridStyleC}>Target</div>
            </Card.Grid>
            <Card.Grid style={gridStyleD}>
              <hr />
              <div style={{ fontWeight: "bold" }}>Special Ability:</div>
              <div style={{ margin: "6px 0 0 0 ", whiteSpace: "pre-wrap" }}>
                {formattedu}
              </div>
            </Card.Grid>
            <Card.Grid style={gridStyleD}>
              <hr />
              <div style={{ fontWeight: "bold" }}>Description:</div>
              <div style={{ margin: "6px 0 0 0 ", whiteSpace: "normal" }}>
                {formattedft}
              </div>
            </Card.Grid>
          </Card.Grid>
        </Card>
      </div>
    );
    return catExists;
  }
}

export default SingleEnemyCard;



// WEBPACK FOOTER //
// ./src/components/table/SingleEnemyCard.js